module.exports = __webpack_public_path__ + "static/media/flying.8de2c46a.mov";